import React, {memo, useEffect, useState} from 'react';

import {Paper, Grid, Typography, Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {useHistory, useParams} from 'react-router-dom';
import moment from 'moment';
import theme from './style';
import {BorderButton, BackButton} from '../../components/buttons';
import {BorderSelect, DatePicker, SingleCheck, TextInput} from '../../components/inputs';
import Label from '../../components/label';
import {
  fetchCustomerDetail,
  addCustomerFeeRow,
  fetchCustomerFeeRow,
  deleteInvoiceRow
} from '../../redux/actions/customer/customerDetail';
import {fetchFeesList, fetchRecurringFeesList, deleteRecurringFee, addRecurringFee} from '../../redux/actions/invoices';
import {CustomerFees as Table} from '../../components/tables';
import {CustomerRecurringFees as RecurringFeesTable} from "../../components/tables";
import {useConfig} from "../../context/configContext";
import translate from '../../misc/applyTranslation';

const DAYS_OF_MONTH = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28"];

const AddInvoiceFee = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const history = useHistory();
  const params = useParams();
  const [dateErrors, setDateErrors] = useState({ start_date: '', end_date: '' });
  const [open, setOpen] = useState(false)
  const [data, setData] = useState({
    customer_id: params.id,
    invoice_row_id: undefined,
    fee_id: undefined,
    inv_row_amount: '',
    inv_row_vat: undefined,
    inv_row_text: ''
  });
  const [recurringFeeData, setRecurringFeeData] = useState({
    customer_id: params.id,
    active: false,
    start_date: moment().unix(),
    end_date: '',
    fee_name: undefined,
    amount: '',
    fee_id: undefined,
    recurring: '',
    recurring_fee_id: ''
  })
  const [update, setUpdate] = useState(false);
  const [createRecurringFee, setCreateRecurringFee] = useState(false);
  const [openRecurringFee, setOpenRecurringFee] = useState(false);
  const {
    fetchCustomerDetail,
    addCustomerFeeRow,
    access_token,
    refresh_token,
    customerData,
    fetchFeesList,
    fees,
    fetchCustomerFeeRow,
    feeRows,
    deleteInvoiceRow,
    fetchRecurringFeesList,
    recurringFees,
    deleteRecurringFee,
    addRecurringFee
  } = props;
  const handleOpen = () => {
    setUpdate(false);
    setOpen(true);
    setCreateRecurringFee(false);
    setOpenRecurringFee(false);
  }
  const handleOpenRecurringFee = () => {
    setUpdate(false);
    setOpen(false);
    setCreateRecurringFee(true);
    setOpenRecurringFee(true);
  }
  const handleClose = () => {
    setData({
      customer_id: params.id,
      invoice_row_id: undefined,
      fee_id: undefined,
      inv_row_amount: '',
      inv_row_vat: undefined,
      inv_row_text: ''
    })
    setOpen(false);
  }

  const handleCloseRecurringFee = () => {
    setRecurringFeeData({
      customer_id: params.id,
      active: false,
      start_date: moment().unix(),
      end_date: null,
      fee_name: undefined,
      amount: '',
      fee_id: undefined,
      recurring: '',
      recurring_fee_id: ''
    });
    setOpenRecurringFee(false);
  }
  const handleChangeFee = (e) => {
    let row_amount;
    if (update) {
      row_amount = data.inv_row_amount;
    } else {
      row_amount = fees.find(item => Number(item.id) === Number(e)).fee_amount / 100;
    }
    setData({...data, fee_id: e, inv_row_text: fees.find(item => Number(item.id) === Number(e)).fee_name, inv_row_amount: row_amount})
  }
  const handleChangeRecurringFee = e => {
    setRecurringFeeData({...recurringFeeData, fee_id: e})
  }
  const handleValueChange = (value, key) => {
    let lastChar = value.charAt(value.length - 1);
    if (/^\d+$/.test(lastChar) || value === '-' || value.length === 0 || lastChar === '.') {
      if (key === "amount") { // For recurring fee
        setRecurringFeeData({...recurringFeeData, [key]: value});
      } else {
        setData({...data, [key]: value});
      }
    }
  }
  const handleSubmit = () => {
    addCustomerFeeRow({
      id: params.id,
      access_token,
      refresh_token,
      new: data.invoice_row_id ? false : true,
      ...data,
    })
    handleClose();
  }
  const handleSubmitRecurringFee = () => {
    console.log(recurringFeeData)
    addRecurringFee({
      access_token,
      refresh_token,
      customer_id: params.id,
      new: createRecurringFee,
      fee_id: recurringFeeData.fee_id,
      active: recurringFeeData.active,
      start_date: recurringFeeData.start_date,
      end_date: recurringFeeData.end_date,
      recurring: recurringFeeData.recurring,
      recurring_fee_id: recurringFeeData.recurring_fee_id
    })
    handleCloseRecurringFee();
  }
  const handleEdit = (row) => {
    setUpdate(true);
    setCreateRecurringFee(false);
    setData({
      customer_id: row.customer_id,
      invoice_row_id: row.id,
      fee_id: row.fee_type_id,
      inv_row_amount: row.inv_row_amount / 100,
      inv_row_vat: row.inv_row_vat,
      inv_row_text: row.inv_row_text
    })
    setOpenRecurringFee(false);
    setOpen(true);
  }
  const handleEditRecurringFee = row => {
    setUpdate(false);
    setCreateRecurringFee(false);
    setRecurringFeeData({
      ...recurringFeeData,
      customer_id: row.customer_id,
      fee_id: row.fee_id,
      amount: row.fee_amount,
      active: row.active,
      recurring: row.recurring,
      start_date: row.start_date,
      end_date: row.end_date,
      recurring_fee_id: row.id
    })
    setOpenRecurringFee(true);
    setOpen(false);
  }
  const handleDelete = (id) => {
    deleteInvoiceRow({
      access_token,
      refresh_token,
      inv_row_id: id,
      id: params.id,
    })
  }
  const handleDeleteRecurringFee = id => {
    deleteRecurringFee({
      access_token,
      refresh_token,
      recurringFeeId: id,
      customer_id: params.id
    })
  }
  useEffect(() => {
    fetchFeesList({
      access_token,
      refresh_token,
    })
    fetchCustomerDetail({
      access_token,
      refresh_token,
      customer_id: params.id,
    })
    fetchCustomerFeeRow({
      access_token,
      refresh_token,
      id: params.id,
    })
    fetchRecurringFeesList({
      access_token,
      refresh_token,
      customer_id: params.id
    })
    // eslint-disable-next-line
  }, [])
  return (
    <React.Fragment>
      <div className={classes.backContainer}>
        <BackButton onClick={e => history.goBack()} text={translate('', 'button_back')}/>
      </div>
      <Paper elevation={4} className={classes.clientBox}>
        <div
          className='title'>{`${translate('edit-fee', 'label_customer')} ${customerData.name} ${customerData.name2}`}</div>
        <div>{`${translate('edit-fee', 'label_customer_id')} ${customerData.props_cust_number}`}</div>
        <div>{customerData.address1}</div>
        <div>{`${customerData.post_code} ${customerData.city}`}</div>
        <div>{customerData.country}</div>
        <div>{customerData.email1}</div>

        <Table data={feeRows.invoice_rows} onEdit={handleEdit} onDelete={handleDelete}/>
        <Grid container className='buttonGroup'>
          <Grid item xs={12} sm={3}>
            <BorderButton onClick={handleOpen} text={translate('', 'button_add')}/>
          </Grid>
        </Grid>
      </Paper>

      {(config.recurring_fees_enabled) &&


      <Paper elevation={4} className={classes.clientBox}>
        <div className="title">
          {translate('edit-fee', 'panel_title_supplier_recurring_fees_set_on_customer_connection')}
        </div>
        <RecurringFeesTable data={recurringFees} onEdit={handleEditRecurringFee} onDelete={handleDeleteRecurringFee}/>
        <Grid container className='buttonGroup'>
          <Grid item xs={12} sm={3}>
            <BorderButton onClick={handleOpenRecurringFee} text={translate('', 'button_add')}/>
          </Grid>
        </Grid>
      </Paper>

      }

      <Paper elevation={4} className={classes.invoiceBox}>
        <Typography
          className='title'>{translate('edit-fee', 'panel_title_supplier_fees_set_on_customer_connection')}</Typography>
        {feeRows.supplier_invoice_rows.map(item =>
          <Grid container key={item.id}>
            <Grid item xs={12} sm={4}>
              {item.supplier_name}
            </Grid>
            <Grid item xs={12} sm={4}>
              {item.inv_row_vat}
            </Grid>
            <Grid item xs={12} sm={4}>
              {item.fee_start_date ? moment.unix(item.fee_start_date).format('YYYY-MM-DD') : '-'}
            </Grid>
          </Grid>
        )}
      </Paper>
      

      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{translate('edit-fee', 'dialog_title_manage_fee')}</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Grid container className='buttonGroup'>
            <Grid item xs={12} sm={6}>
              <Label text={translate('edit-fee', 'dialog_label_fees')}/>
              <BorderSelect
                selected={data.fee_id}
                items={fees.map(item => {
                  return {id: item.id, text: item.fee_name}
                })}
                onChange={handleChangeFee}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Label text={translate('edit-fee', 'dialog_label_amount')}/>
              <TextInput value={data.inv_row_amount} placeholder=''
                         onChange={(e) => handleValueChange(e.target.value, 'inv_row_amount')}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <BorderButton onClick={handleClose} text={translate('', 'button_cancel')}/>
          <BorderButton onClick={handleSubmit} disabled={!data.inv_row_amount || !data.fee_id}
                        text={translate('', 'button_save')}/>
        </DialogActions>
      </Dialog>

      <Dialog open={openRecurringFee} onClose={handleCloseRecurringFee} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title-recuyrring-fee">
          {translate('edit-fee', 'dialog_title_manage_recurring_fee')}
        </DialogTitle>
        <DialogContent>
          <Grid container className="buttonGroup">
            <Grid item xs={12} sm={6}>
              <Label text={translate('edit-fee', 'dialog_label_fees')}/>
              <BorderSelect
                selected={recurringFeeData.fee_id}
                items={fees.map(item => {
                  return {id: item.id, text: item.fee_name}
                })}
                onChange={handleChangeRecurringFee}
              />
            </Grid>
           {/* <Grid item xs={12} sm={6}>
              <Label text={translate('edit-fee', 'dialog_label_amount')}/>
              <TextInput value={recurringFeeData.amount} onChange={e => handleValueChange(e.target.value, 'amount')}/>
            </Grid>*/}
            <Grid item xs={12} sm={6}>
              <Label text={translate('edit-fee', 'dialog_label_recurringh')}/>
              <BorderSelect
                selected={recurringFeeData.recurring}
                items={DAYS_OF_MONTH.map((item, index) => {
                  return {id: index + 1, text: item}
                })}
                onChange={e => setRecurringFeeData({...recurringFeeData, recurring: e})}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Label text={translate('edit-fee', 'dialog_label_start_date')}/>
              <DatePicker value={moment.unix(recurringFeeData.start_date)} 
              onChange={e => {
                const newStart = moment(e).startOf('day').unix();
                const end = recurringFeeData.end_date;

                if (end && end < newStart) {
                  setDateErrors({
                    start_date: translate('edit-fee', 'dialog_error_start_date'),
                    end_date: translate('edit-fee', 'dialog_error_end_date'),
                  });
                  return;
                }

                setDateErrors({ start_date: '', end_date: '' });
                setRecurringFeeData({ ...recurringFeeData, start_date: newStart });
              }}
              errorText={dateErrors.start_date}
              label="Test"/>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Label text={translate('edit-fee', 'dialog_label_end_date')}/>
              <DatePicker value={Number(recurringFeeData.end_date) !== 0 && recurringFeeData.end_date ? moment.unix(recurringFeeData.end_date) : null}
                placeholder={translate('edit-fee', 'dialog_label_end_date')}
                onChange={e => {
                  const newEnd = e ? moment(e).unix() : null;
                  const start = recurringFeeData.start_date;

                  if (newEnd && newEnd < start) {
                    setDateErrors({
                      start_date: translate('edit-fee', 'dialog_error_start_date'),
                      end_date: translate('edit-fee', 'dialog_error_end_date'),
                    });
                    return;
                  }

                  setDateErrors({ start_date: '', end_date: '' });
                  setRecurringFeeData({ ...recurringFeeData, end_date: newEnd });
                }}
                errorText={dateErrors.end_date}
                label="Test"/>
            </Grid>
            <Grid item xs={12} sm={6} style={{display: "flex", alignItems: "end", paddingLeft: 11}}>
              <SingleCheck
                value={Number(recurringFeeData.active) === 1}
                text={translate('edit-fee', 'dialog_label_active')}
                style={{transform: "scale(2)"}}
                containerStyle={{marginBottom: 0}}
                onChange={e => setRecurringFeeData({...recurringFeeData, active: e})}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <BorderButton onClick={handleCloseRecurringFee} text={translate('', 'button_cancel')}/>
          <BorderButton onClick={handleSubmitRecurringFee} text={translate('', 'button_save')}/>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
AddInvoiceFee.propTypes = {
  fetchCustomerDetail: PropTypes.func.isRequired,
  access_token: PropTypes.string.isRequired,
  refresh_token: PropTypes.string.isRequired,
  customerData: PropTypes.object.isRequired,
}
const mapStateToProps = store => ({
  access_token: store.login.access_token,
  refresh_token: store.login.refresh_token,
  customerData: store.customer.customerData,
  fees: store.invoices.fees,
  feeRows: store.customer.feeRows,
  recurringFees: store.invoices.recurringFees
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    fetchCustomerDetail,
    fetchFeesList,
    addCustomerFeeRow,
    fetchCustomerFeeRow,
    deleteInvoiceRow,
    fetchRecurringFeesList,
    deleteRecurringFee,
    addRecurringFee
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(memo(AddInvoiceFee));
